import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// react-snap prerenders every public route to static HTML (see package.json > reactSnap).
// That HTML is a DOM snapshot rather than React SSR output, so adjacent text nodes are
// merged and React 19 always reports a hydration text mismatch (error #418) and then
// re-renders on the client anyway. We therefore mount a fresh client render over the
// prerendered markup: crawlers still get the full static HTML, users still get the fast
// first paint, and there is no mismatch noise or half-hydrated state.
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
